"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var interpreter_utils_1 = require("../../interpreter-utils");
var properties_node_1 = require("./properties-node");
var visibility_condition_1 = require("./visibility-condition");
var CellPropertiesModel = /** @class */ (function (_super) {
    __extends(CellPropertiesModel, _super);
    function CellPropertiesModel(id, template, columnCount, height, style, visibility) {
        if (visibility === void 0) { visibility = new visibility_condition_1.VisibilityCondition(undefined, undefined); }
        var _this = _super.call(this, id) || this;
        _this.template = template;
        _this.columnCount = columnCount;
        _this.height = height;
        _this.style = style;
        _this.visibility = visibility;
        return _this;
    }
    CellPropertiesModel.createEmpty = function (id) {
        return new CellPropertiesModel(id, CellPropertiesModel.defaultTemplate, CellPropertiesModel.count, undefined, immutable_1.Map());
    };
    CellPropertiesModel.fromJs = function (cellObject, conditionReader) {
        var visibilityRawData = interpreter_utils_1.getOptionalProperty(cellObject, 'cellProperties.visibility', null);
        return new CellPropertiesModel(interpreter_utils_1.getRequiredProperty(cellObject, 'id'), interpreter_utils_1.getOptionalProperty(cellObject, 'cellProperties.style.template', CellPropertiesModel.defaultTemplate), {
            'xs': interpreter_utils_1.getOptionalProperty(cellObject, 'cellProperties.column_count.xs', CellPropertiesModel.count.xs),
            's': interpreter_utils_1.getOptionalProperty(cellObject, 'cellProperties.column_count.s', CellPropertiesModel.count.s),
            'm': interpreter_utils_1.getOptionalProperty(cellObject, 'cellProperties.column_count.m', CellPropertiesModel.count.m)
        }, interpreter_utils_1.getOptionalProperty(cellObject, 'cellProperties.height', undefined), immutable_1.fromJS(interpreter_utils_1.getOptionalProperty(cellObject, 'cellProperties.style', {})), new visibility_condition_1.VisibilityCondition(conditionReader.readCondition(visibilityRawData), visibilityRawData));
    };
    CellPropertiesModel.prototype.toJS = function () {
        return __assign({ id: this.id, column_count: this.columnCount, style: this.style.set('template', this.template).toJS(), visibility: this.visibility.toJS() }, this.height && { height: this.height });
    };
    CellPropertiesModel.defaultTemplate = 'transparent';
    CellPropertiesModel.count = {
        xs: 4,
        s: 8,
        m: 12,
    };
    return CellPropertiesModel;
}(properties_node_1.PropertiesNode));
exports.CellPropertiesModel = CellPropertiesModel;
//# sourceMappingURL=cell-properties-model.js.map